// API Client
export { default as apiClient } from './client';
export type { ApiResponse, ApiError } from './client';

// Authentication API
export { authApi } from './auth';
export type {
  LoginRequest,
  LoginResponse,
  RefreshTokenResponse,
  MicrosoftLoginRequest,
} from './auth';

// Bachelor Degrees API
export { bachelorDegreesApi } from './bachelor-degrees';
export type {
  BachelorDegree,
  BachelorDegreeFilters,
  BachelorDegreeListResponse,
  BulkImportResponse as BachelorBulkImportResponse,
} from './bachelor-degrees';

// Ensure APIs are available at module level to prevent undefined errors
import { bachelorDegreesApi as bachelorApi } from './bachelor-degrees';
if (typeof bachelorApi?.getAll !== 'function') {
  console.warn('Bachelor Degrees API not properly initialized');
}

// Master Degrees API
export { masterDegreesApi } from './master-degrees';
export type {
  MasterDegree,
  MasterDegreeFilters,
  MasterDegreeListResponse,
  BulkImportResponse as MasterBulkImportResponse,
} from './master-degrees';

// Language Certificates API
export { languageCertificatesApi } from './language-certificates';
export type {
  LanguageCertificate,
  LanguageCertificateFilters,
  LanguageCertificateListResponse,
  BulkImportResponse as LanguageCertificateBulkImportResponse,
} from './language-certificates';

// GDQP Certificates API
export { gdqpCertificatesApi } from './gdqp-certificates';
export type {
  GdqPCertificate,
} from './gdqp-certificates';

// Awards API
export { awardsApi } from './awards';
export type {
  Award,
  AwardFilters,
  AwardListResponse,
  BulkImportResponse as AwardBulkImportResponse,
} from './awards';

// Users API
export { usersApi } from './users';
export type {
  User,
  CreateUserRequest,
  UpdateUserRequest,
  UserFilters,
  UserListResponse,
  ChangePasswordRequest,
  ResetPasswordRequest,
  BulkUserAction,
} from './users';

// Public Search API
export { publicSearchApi } from './public-search';
export type {
  SearchResult,
  PublicSearchRequest,
  PublicSearchResponse,
} from './public-search';